export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Orlando, FL",
    text: "Fast, honest, and high quality work. Thomas Roofing fixed our leak within 24 hours of calling. Couldn't be happier.",
    rating: 5,
  },
  {
    id: 2,
    name: "David R.",
    location: "Orlando, FL",
    text: "They fixed a leak that three other companies couldn't find. The team was thorough, professional, and fair on pricing.",
    rating: 5,
  },
  {
    id: 3,
    name: "Linda K.",
    location: "Winter Park, FL",
    text: "Professional and so easy to work with. Clear communication every step of the way. New roof looks amazing.",
    rating: 5,
  },
  {
    id: 4,
    name: "Marcus T.",
    location: "Titusville, FL",
    text: "After a bad storm, Thomas Roofing came out immediately. They handled everything and the crew was respectful of our property.",
    rating: 5,
  },
  {
    id: 5,
    name: "Jennifer A.",
    location: "Kissimmee, FL",
    text: "No upsells, no pressure. Just honest advice and top-quality work. They told me exactly what needed to be fixed and did it.",
    rating: 5,
  },
  {
    id: 6,
    name: "Robert H.",
    location: "Melbourne, FL",
    text: "My roof has never looked better. The crew was incredibly clean and professional. Would recommend to any homeowner.",
    rating: 5,
  },
];
